export const universalStyles = {
	header: {
		backgroundColor: '#f7d020',
	},
	sidebar: {
		backgroundColor: '#000',
		color: 'white',
	},
	button: {
		backgroundColor: '#f8cf1f',
		color: '#000000',
		border: '1px solid #000000',
		fontWeight: 600,
		':hover': {
			color: '#ffffff',
			backgroundColor: '#000000',
		},
	},
	title: {
		color: 'black',
	},
	text: {
		color: '#000000',
	},
	table: {
		headerBackgroundColor: '#000000',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Universal Parking Platform',
	},
	logo: {
		small: {
			// Will come from an s3 bucket eventually
			src: '/universal/universal-icon-white-yellow.svg',
			height: 45,
			width: 45,
		},
		large: {
			src: '/universal/universal-logo-white-yellow.svg',
			height: 45,
			width: 125,
		},
	},
	favicon: {
		src: '/universal/universal-icon-white-yellow.svg',
	},
	socials: {
		instagram: 'https://www.instagram.com/parkwithuniversal',
		facebook: 'https://www.facebook.com/universalparking/',
		linkedIn: 'https://www.linkedin.com/company/universalparking/',
	},
	siteUrl: 'https://universalparking.com/',
	orgName: 'Universal Parking',
};
